<template>
  <div class="content importList">
    <!-- <div class="search-area">
      <div class="w100f t-left mb15"><b>选择需要导入的数据</b></div>
      <div class="import-a-sty">
        <a class="fontC-4fa1a4">上传工资条文件</a>
      </div>
    </div> -->
    <div class="search-area" style="padding-top:26px;">
      <div class="state-back " size="small" @click="$router.go(-1)">返回</div>
      <div class="import-sty">
        <el-steps :active="active" align-center>
          <el-step title="上传文件"></el-step>
          <el-step title="确认数据"></el-step>
          <el-step title="导入完成"></el-step>
        </el-steps>
        <div v-if="active == 0" style="width:1000px;">
          <div class="ml71">
            <div style="display:flex;">
              <section  class="input-item">
                <div class="search-area-div"><span style="color:red">*</span>企业名称：</div>
                <el-select v-model="sendTenantGuid" placeholder="请选择"  style="width: 250px" filterable >
                  <el-option v-for="item in sendTenantList" :key="item.guid" :label="item.sendTenantName" :value="item.sendTenantGuid">
                  </el-option>
                </el-select>
              </section>
              <section class="input-item">
                <div class="search-area-div"><span style="color:red">*</span>费用类型：</div>
                <el-select v-model="salaryType" placeholder="请选择"  style="width: 250px" filterable >
                  <el-option v-for="item in salaryTypeList" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </section>
            </div>
            <div style="display:flex;">
              <section class="input-item">
                <div class="search-area-div"><span style="color:red">*</span>费用月份：</div>
                <el-date-picker
                  style="width: 250px"
                  value-format="yyyy-MM"
                  v-model="accountMonth"
                  type="month"
                  placeholder="选择月"
                >
                </el-date-picker>
              </section>
               <section class="input-item">
                <div class="search-area-div"><span style="color:white">*</span>温馨提示：</div>
                <el-input
                  style="width: 250px"
                  v-model="note"
                  placeholder="请输入"
                >
                </el-input>
              </section>
            </div>
            <div style="display:flex;">
               <section class="input-item">
                <div class="search-area-div"><span style="color:white">*</span>标题：</div>
                <div class="salary-title">
                <span style="margin-right:15px;" v-if="accountMonth||salaryType">{{accountMonth}}{{getFree(salaryType)}}</span>
                <el-input style="width: 250px;" v-model="title" placeholder="请输入">
                </el-input>
                </div>
              </section>
            </div>
            

            <!-- <div class="mt15 import-wrap" style="margin-top: 30px">
              下载模板：<el-button plain size="medium">下载文件模板</el-button>
            </div> -->
            <div class="mt15 mt15 h120 import-wrap">
              <p class="fl">导入文件：</p>
              <el-upload
                class="upload-demo fl"
                ref="upload"
                action="#"
                :before-upload="beforeUpload"
                multiple
                :limit="1"
                accept=".xlsx,.xsl,.xls,.xlsm"
                :auto-upload="false"
                :on-change="changeFile"
                :on-exceed="handleExceed"
              >
                <el-button size="medium" type="info" v-loading.fullscreen.lock="fullscreenLoading" 
                  >上传工资条</el-button
                >
                <div slot="tip" class="el-upload__tip" style="    margin-left: 10px;line-height: 20px;">
                  1、直接上传你现有的Excel工资表，无需模版，填写资料时请确保包含<span style="color:#4fa1a4">“姓名”、“手机号”、“身份证”、“实发工资”</span>字段，并且内容非空，前三个字段顺序不可调整；<br />
                  2、文件大小不能超过10M，且文件类型为：*.xls，*.xlsx。<br />
                  3、<a class="down-link" @click="downloadExcel(1)">工资条模版点击下载</a> 
                 <a class="down-link" style="margin-left:6px;" @click="downloadExcel(2)">业务费用模版点击下载</a> 
                </div>
              </el-upload>
            </div>
          </div>
          <div class="mt15 t-right">
            <el-button size="medium" type="info" @click="next()">下一步</el-button>
          </div>
        </div>
      </div>
      <div v-if="active == 1" class="mt15">
        <div class="summary-sty">
          预计导入<b class="fontC-4fa1a4"> {{ totalRows }} </b>条数据，其中<b class="fontC-4fa1a4"> {{ errorRows }} </b
          >条可能有误，请调整后再导入
          <a class="txt-color-blue ml10" @click="getDataAll()">全部数据 | </a>
          <a class="txt-color-blue" @click="getDataErrorFlagY()">只看错误数据 | </a>
          <a class="txt-color-blue" @click="getDataErrorFlagN()">只看准确数据</a>
          <span style="float: right; padding-right: 10px; color: #4fa1a4; cursor: pointer" @click="pitchDelet"
            >批量删除</span
          >
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="colA" label="姓名"  header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colA" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colB" label="手机号"  header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colB" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
           <el-table-column prop="colC" label="身份证号"  header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colC" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
       
          <el-table-column prop="colE"  v-if="labelList[0]" :label="labelList[0]"  header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colE" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colF" v-if="labelList[1]" :label="labelList[1]"  header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colF" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colG" v-if="labelList[2]" :label="labelList[2]"  header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colG" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
           <el-table-column prop="colH" v-if="labelList[3]" :label="labelList[3]"  header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colH" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
           <el-table-column prop="colI" v-if="labelList[4]" :label="labelList[4]"  header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colI" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="colJ"  v-if="labelList[5]" :label="labelList[5]" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colJ" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colK" v-if="labelList[6]" :label="labelList[6]"  header-align="center" align="center" width="250">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colK" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colL" v-if="labelList[7]" :label="labelList[7]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colL" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="colM" v-if="labelList[8]"  :label="labelList[8]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colM" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="colN" v-if="labelList[9]"  :label="labelList[9]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colN" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colO" v-if="labelList[10]" :label="labelList[10]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colO" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
           <el-table-column prop="colP"  v-if="labelList[11]" :label="labelList[11]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colP" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
              <el-table-column prop="colQ" v-if="labelList[12]"  :label="labelList[12]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colQ" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colR" v-if="labelList[13]" :label="labelList[13]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colR" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
            <el-table-column prop="colS" v-if="labelList[14]" :label="labelList[14]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colS" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colT" v-if="labelList[15]" :label="labelList[15]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colT" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
            <el-table-column prop="colU" v-if="labelList[16]" :label="labelList[16]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colU" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
            <el-table-column prop="colV" v-if="labelList[17]" :label="labelList[17]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colV" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
            <el-table-column prop="colW" v-if="labelList[18]"  :label="labelList[18]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colW" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
            <el-table-column  v-if="labelList[19]" prop="colX"   :label="labelList[19]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colX" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
            <el-table-column  v-if="labelList[20]" prop="colY"  :label="labelList[20]"  header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colY" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="labelList[21]" prop="colZ" :label="labelList[21]" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colZ" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="labelList[22]"  prop="colAa" :label="labelList[22]"  header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colAa" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="labelList[23]" prop="colAb" :label="labelList[23]"  header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colAb" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="labelList[24]" prop="colAc" :label="labelList[24]"  header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colAc" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="labelList[25]" prop="colAd" :label="labelList[25]"  header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colAd" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="labelList[26]" prop="colAe" :label="labelList[26]"  header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colAe" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="labelList[27]" prop="colAf" :label="labelList[27]"  header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colAf" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="errorInfo"
            label="错误信息"
            header-align="center"
            align="center"
            fixed="right"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.errorInfo | errorInfo }}
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" fixed="right" width="150">
            <template slot-scope="scope">
              <a class="txt-color" @click="save(scope.row)">保存 | </a>
              <a class="txt-color-red" @click="deletes(scope.row.guid)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pt pb back-color-fff"
          style="padding: 16px"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 100, 200]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination>
        <div class="mt15 t-right">

          <el-button size="medium" plain @click="active = 0">上一步</el-button>
          <el-button size="medium" type="info" @click="nextImport()" v-loading.fullscreen.lock="fullscreenLoading"
            >导入</el-button
          >
        </div>
      </div>

      <div class="font-S16 mt50 h150" v-if="active == 2">
        <img width="64" height="64" src="../../assets/images/right.png" /><br /><br />
        导入成功，本次共导入<b class="fontC-4fa1a4">{{ importSum }}</b>条数据<br />
       <div  class="fontC-4fa1a4" @click="sendSalary" style="margin-top:10px;cursor:pointer;">发送工资条</div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      url: `/${serverConfig.msSalesPerformService}/import-data/salary-note`,
      active: 0,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        importType: '0009',
        errorFlag: '',
        tenantGuid:''
      },
      importSum: 0,
      salaryGuid:'',
      loading: true,
      tableData: [],
      provinceList: areaJson,
      cityList: [],
      districtList: [],
      guids: [],
      errorRows: 0,
      totalRows: 0,
      fullscreenLoading: false,
      doctorTypeOption: [],
      checkedList: [],
      note:'工资条属于敏感信息，请注意保密',
      title:'',
      salaryType: '',
      accountMonth: '',
      salaryTypeList: [{value:1,text:'工资条'},{value:2,text:'业务费用'},{value:3,text:'其他'}],
      sendTenantGuid:"",
      sendTenantList:[],
      labelList:[],
    };
  },
  created() {
    this.getSendTenantList();
  },
  methods: {
    getFree(salaryType) {
      if (salaryType == 1) {
        return '工资条'
      }
      if (salaryType == 2) {
        return '业务费用'
      }
      if (salaryType == 3) {
        return '其他'
      }
    },
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    toLink(link) {
      this.$router.push({ path: link });
    },
    province(pr) {
      let self = this;
      self.cityList = [];
      self.provinceList.forEach(function (i) {
        if (i.label == pr) {
          if (i.children != null && i.children != '') {
            i.children.forEach(function (j) {
              self.cityList.push(j);
            });
          }
        }
      });
    },
    city(ci) {
      let self = this;
      console.log(self.cityList);
      self.districtList = [];
      self.cityList.forEach(function (i) {
        if (i.label == ci) {
          if (i.children != null && i.children != '') {
            i.children.forEach(function (j) {
              self.districtList.push(j);
            });
          }
        }
      });
    },
    downloadExcel(type) {
      if (type == 1) {
        window.open('/工资条明细模版.xlsx');
      }
      if (type == 2) {
        window.open('/业务费用明细模版.xlsx');
      }

    },
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!');
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    changeFile(file, fileList) {
      let self = this;
      let isLt5M = file.size / 1024 / 1024 < 5;
      if(this.sendTenantGuid==''){
        self.$message.error('请选择企业名称');
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      if (this.salaryType == '') {
        self.$message.error('请选择费用类型');
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      if (this.accountMonth == '') {
        self.$message.error('请选择所属月份');
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      if (!isLt5M) {
        self.$message.error('上传文件大小不能超过 5MB');
        file = null;
        fileList = [];
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
      } else {
        self.fullscreenLoading = true;
        let formData = new FormData();
        formData.append('file', file.raw); //传文件
        let url = self.url +'?progressGuid=' + self.generateUUID() +  '&accountMonth=' + self.accountMonth.replace('-', '') + '&tenantGuid=' +self.sendTenantGuid +'&title=' + self.title + '&note=' +self.note +'&importType=' + self.salaryType;
        self.api.postFile(url, formData).then(function (res) {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message({
              type: 'success',
              message: '上传成功',
            });
          } else {
            self.$message({
              type: 'error',
              message: res.data.msg,
            });
            self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
            return false;
          }
        });
      }
    },
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
      return uuid;
    },
    next() {
      let self = this;
      self.active = 1;
      self.getData(true);
    },
    getDataAll() {
      let self = this;
      self.page.errorFlag = '';
      self.getData(true);
    },
    getDataErrorFlagY() {
      let self = this;
      self.page.errorFlag = 'Y';
      self.getData(true);
    },
    getDataErrorFlagN() {
      let self = this;
      self.page.errorFlag = 'N';
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableData = [];
      self.page.tenantGuid = self.sendTenantGuid;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/import-data/get-import-intermediate-data`, self.page)
        .then((res) => {
            self.loading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.details.records;
            self.labelList = self.tableData[0].colAn.split(',')
            self.errorRows = res.data.data.errorRows;
            self.totalRows = res.data.data.totalRows;
            self.page.totalPage = res.data.data.details.totalPages;
            self.page.totalRows = res.data.data.details.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    save(row) {
      let self = this;
      row.errorFlag = 'N';
      row.errorInfo = '';
      self.loading = true;
      self.api.put(`/${serverConfig.msSalesPerformService}/import-data/update-intermediate-data`, row).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('保存成功');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
          self.loading = false;
        }
      });
    },
    deletes(guid) {
      let self = this;
      self.guids = [];
      self.guids.push(guid);
      self.loading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/import-data/delete-intermediate-data`, self.guids)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('删除成功');
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
            self.loading = false;
          }
        });
    },
    // 多选删除
    handleSelectionChange(val) {
      console.log('多选删除', val);
      let arr = [];
      val.forEach((item) => {
        arr.push(item.guid);
      });
      this.checkedList = arr;
    },
    pitchDelet() {
      if (this.checkedList.length) {
        let self = this;
        self.loading = true;
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/import-data/delete-intermediate-data`, self.checkedList)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
              self.loading = false;
            }
          });
      } else {
        this.$message.error('请勾选需要删除的数据！');
      }
    },
    nextImport() {
      let self = this;
      self.fullscreenLoading = true;
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/import-data/finish-salary-note?tenantGuid=` +
            self.sendTenantGuid +
            '&progressGuid=' +
            this.generateUUID(),
        )
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.importSum = res.data.data.count;
            self.salaryGuid = res.data.data.guid;

            self.$message.success('导入成功');
            self.active = 2;
          } else {
            self.active = 1;
            self.getData(true);
            self.$message.error(res.data.msg);
          }
        });
    },
    sendSalary(){
      let self = this;
      let req = {
        guid: this.salaryGuid
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/salary/note/get-list-total`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data.records[0]
            this.$router.push({
              path:'payRollDetail',
              query:{
                detail:JSON.stringify(data)
              }
            })
        } else {
          self.$message.error(res.data.msg);
        }
      });

    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      self.getData(false);
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      self.getData(false);
    },
  },
};
</script>
<style  scoped>
.importList /deep/ .el-step__title.is-finish{
   color: #4fa1a4;
}
 .importList /deep/ .el-step__head.is-finish{
    color: #4fa1a4;
    border-color: inherit;
}
.importList /deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.importList /deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4 ;
}
.importList /deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
.importList /deep/ .is-wait .el-step__icon.is-text{
  border-color: inherit;
  color:#C0C4CC;
}
.importList /deep/ .is-wait .el-step__icon-inner{
    color:#C0C4CC;
}
.importList /deep/ .is-process  .el-step__icon.is-text{
    border-color: #4fa1a4 ;
}
.importList /deep/ .is-finish .el-step__line{
  background-color:#4fa1a4;
}
.input-item {
  margin: 20px 20px 0 0;
  display: flex;
}
.input-item .search-area-div {
  text-align: left;
  width: 82px;
}
.import-wrap /deep/ .el-button {
  margin-left: 12px;
}
.down-link{
  text-decoration: underline;
  color:#4fa1a4 ;
  cursor:pointer;
}
.salary-title{
    display: flex;
    align-items:center;
}
.salary-title span{
    margin-right:5px;
}
.txt-color-blue{
  color:#999;
}
.state-back {
  width: 84px;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  text-align: center;
  cursor: pointer;
  border: 1px solid #C0C0C0;
  position: absolute;
  left: 20px;
  top: 20px
}
.search-area{
  position:relative;
}

</style>